import { selector, useRecoilValue } from 'recoil';
import { isDateInRange } from 'functions';
import { DataType } from 'enums';
import { searchResultsFilter, searchResults, useSetRefreshState, searchQuery } from 'state';
import { DisputeSummary, InvoiceSummary, PaymentDetail, PaymentSummary, SearchResult } from 'types';
import { getAdjustmentFilterDate, getAdjustmentSearchAmount } from './searchResultsFilter';

export const filteredSearchResults = selector<SearchResult[]>({
    key: 'filteredSearchResults',
    get: async ({ get }) => {
        const filter = get(searchResultsFilter);
        const searchQueryValue = get(searchQuery);
        const {
            dataType,
            dateRange,
            startAmount,
            endAmount,
            sort
        } = filter;
        const results = get(searchResults);
        const list = results.filter(({ data, type }) => {
            let amount, date;
            switch (type) {
                case DataType.Dispute:
                    const { disputeAmount, submittedDateUtc } = data as DisputeSummary;
                    amount = disputeAmount;
                    date = submittedDateUtc;
                    break;
                case DataType.Invoice:
                    const { invoiceDate, userVoucherDecimal } = data as InvoiceSummary;
                    amount = userVoucherDecimal;
                    date = invoiceDate;
                    break; 
                case DataType.Payment:
                    const { paymentAmount, paymentDate } = data as PaymentSummary;
                    amount = paymentAmount;
                    date = paymentDate;
                    break;
                case DataType.CustomerDeduction:
                case DataType.DotBillback:
                case DataType.CustomerDedRepay: 
                case DataType.Credit:
                case DataType.Unknown:
                    const adjustment = data as PaymentDetail;
                    amount = getAdjustmentSearchAmount(adjustment);
                    date = getAdjustmentFilterDate(adjustment);
                    break;
            }
            return (dataType ? dataType === type : true)
                && isDateInRange(dateRange, date)
                && (startAmount ? (amount !== undefined && amount >= startAmount) : true)
                && (endAmount ? (amount !== undefined && amount <= endAmount) : true);
        });        
        return sort.text === 'Sort By' ? list.sort((a, b) => sort.compare(a, b, searchQueryValue)) : list.sort(sort.compare);
    }
});

export const useFilteredSearchResults = () => useRecoilValue(filteredSearchResults);

export const useRefreshFilteredSearchResults = () => useSetRefreshState(filteredSearchResults);
